module.exports = __webpack_public_path__ + "static/shiela-78a9ca5ca49c4c202e5e637e2f2660a0.webp";